/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Legal_Content_Identity_TextInputs */

const fr_legal_content_identity_text = /** @type {(inputs: Legal_Content_Identity_TextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`L'accès au code source ne confère aucun droit sur les contenus rédactionnels, le logo ou la charte graphique.`)
};

const en_legal_content_identity_text = /** @type {(inputs: Legal_Content_Identity_TextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Access to the source code does not grant any rights over editorial content, the logo, or the visual identity.`)
};

/**
* | output |
* | --- |
* | "Access to the source code does not grant any rights over editorial content, the logo, or the visual identity." |
*
* @param {Legal_Content_Identity_TextInputs} inputs
* @param {{ locale?: "fr" | "en" }} options
* @returns {LocalizedString}
*/
export const legal_content_identity_text = /** @type {((inputs?: Legal_Content_Identity_TextInputs, options?: { locale?: "fr" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Legal_Content_Identity_TextInputs, { locale?: "fr" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_legal_content_identity_text(inputs)
	return en_legal_content_identity_text(inputs)
});